import { addEventListeners, removeEventListeners } from "../utils/dom";

export default class RadioButtonList extends HTMLDivElement {

    connectedCallback() {

        addEventListeners(this.inputs, "focus", this.focusElement);

        // Set checkbox as checked if the custom value is the same as the checkbox value
        if (this.customInput) {
            const customValue = this.customInput.value;

            if (customValue)
                this.customInput.classList.add("active");

            this.radioInputs.forEach(input => {
                if (input.value === customValue) {
                    input.checked = true;
                    input.classList.add("active");
                    this.customInput.classList.remove("active");
                    this.customInput.value = null;
                }
                    
            })
        }
        
    }

    disconnectedCallback() {

        removeEventListeners(this.inputs, "focus", this.focusElement);

    }

    focusElement = (e) => {
        Array.from(this.inputs)
            .filter(input => input != e.target)
            .forEach(input => {
                input.classList.remove("active");

                if (input.checked)
                    input.checked = false;

            });

        e.target.classList.add("active");

    }

    reset() {
        Array.from(this.radioInputs).forEach(input => input.checked = false);

        if (this.customInput)
            this.customInput.value = null;

        Array.from(this.querySelectorAll(".active")).forEach(el => el.classList.remove("active"));
    }

    get inputs() {
        return this.querySelectorAll("input");
    }

    get radioInputs() {
        return this.querySelectorAll("input[type=radio], input[type=checkbox]");
    }

    get customInput() {
        return this.querySelector("input:not([type=radio]):not([type=checkbox])");
    }

}

customElements.define('radio-button-list', RadioButtonList, { extends: 'div' });